import { useAtomValue } from 'jotai';

import { useAnnouncementToast as useBaseAnnouncementToast } from '../components/announcements/useAnnouncementToast';
import { useVideoPlatform } from '../hooks/useVideoPlatform';
import { AppState, UserType } from '../types';
import { roomAtom } from '../video-sdk/core/atoms';
import { useGetCurrentProviderQuery } from './useGetCurrentProviderQuery';

export function useAnnouncementToast() {
  const { data } = useGetCurrentProviderQuery();
  const providerShortId = data?.currentProvider.shortId;
  const isInSession = !!useAtomValue(roomAtom);
  const videoPlatform = useVideoPlatform();

  useBaseAnnouncementToast({
    userId: providerShortId,
    userType: UserType.PROVIDER,
    appState: isInSession ? AppState.MEETING : AppState.WAITING,
    videoPlatform,
  });
}
